import { InviteCodeSection, UsersSection, CleanupSection } from '../components/admin';
import { useAdmin } from '../hooks';
import './AdminPage.css';

export function AdminPage() {
  const { isAdmin, isLoading } = useAdmin();

  if (isLoading) {
    return (
      <div className="admin-page">
        <div className="admin-loading">
          <div className="admin-spinner" />
          <span className="admin-loading-text">Проверка доступа...</span>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="admin-page">
        <div className="admin-access-denied">
          <div className="admin-denied-icon">
            <span className="admin-denied-lock">🔐</span>
          </div>
          <h2 className="admin-denied-title">Доступ запрещён</h2>
          <p className="admin-denied-text">
            Эта страница доступна только администраторам системы
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-page">
      {/* Header */}
      <header className="admin-header">
        <div className="admin-header-icon">⚙️</div>
        <div className="admin-header-content">
          <h1 className="admin-title">Администрирование</h1>
          <p className="admin-subtitle">Управление системой</p>
        </div>
      </header>

      {/* Sections */}
      <div className="admin-sections">
        <InviteCodeSection />
        <UsersSection />
        <CleanupSection />
      </div>
    </div>
  );
}
